import type { ApiAcceptedLanguage, AppSpec } from '@izimi/api';
import type { BaseConfig } from '@izimi/core';
import { citizenApiUrl } from '@izimi/core';

import packageJSON from '../../../../../package.json';

export type Environment = 'local' | 'development' | 'test' | 'acc' | 'production';

class Config implements BaseConfig {
  constructor(public apiUrl: string) {}

  get environment() {
    return appEnv;
  }

  get contactEmail() {
    return 'support@izimi.be';
  }

  get supportPhone() {
    return '+3225050880';
  }

  get supportPhoneFormatted() {
    return '+32 2 505 08 80';
  }
}

const configs: Record<Environment, Config> = {
  local: new Config(citizenApiUrl.local),
  development: new Config(citizenApiUrl.development),
  test: new Config(citizenApiUrl.test),
  acc: new Config(citizenApiUrl.acc),
  production: new Config(citizenApiUrl.production),
};

export const citizenPortalWebsite: Record<ApiAcceptedLanguage, string> = {
  de: 'https://www.notaire.be',
  en: 'https://www.notaire.be',
  fr: 'https://www.notaire.be',
  nl: 'https://www.notaris.be',
};

const getAppEnv = (): Environment | undefined => {
  const { hostname } = window.location;
  const subDomain = hostname.split('.')[0] ?? '';

  const subDomains: Record<string, Environment> = {
    localhost: 'local',
    dev: 'development',
    tst: 'test',
    acc: 'acc',
  };

  return subDomains[subDomain] ?? 'production';
};

export const appEnv: Environment = import.meta.env.VITE_APP_ENV ?? getAppEnv();

export const appSpec: AppSpec = { app: 'web-citizen-portal', version: packageJSON.version };

export default configs[appEnv];
